import React from 'react';
import { Link } from 'react-router-dom';
import { LayoutDashboard } from 'lucide-react';

/**
 * Inline shortcut that opens the "Vista 360" of a client in a new tab.
 * Renders nothing when clientId is empty/falsy so callers can drop it under
 * any client selector without conditional logic.
 *
 *   <Client360Link clientId={formData.client_id} />
 */
export const Client360Link = ({ clientId, className = '', testid = 'view-client-360-link' }) => {
  if (!clientId) return null;
  return (
    <Link
      to={`/clients/${clientId}/360`}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-1.5 text-xs font-semibold text-[#FF6B4A] hover:text-[#E05A3E] transition-colors ${className}`}
      data-testid={testid}
    >
      <LayoutDashboard className="w-3.5 h-3.5" />
      Ver Vista 360 del cliente
    </Link>
  );
};

export default Client360Link;
